import globalStyles from '../../styles/exported.module.scss';

export const CheckedIcon = ({ className, ...rest }: { className?: string } & Partial<HTMLOrSVGElement>) => (
  <svg
    {...(className && { className })}
    {...rest}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="24"
    viewBox="0 0 20 24"
    fill="none"
  >
    <rect y="2" width="20" height="20" rx="4" fill={globalStyles.bdSecondaryLightBlue} />
    <path
      d="M5.61523 12.0922L8.39494 15.3329L14.4176 9.77734"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
